/**
 * Logo component.
 * @module components/theme/Logo/Logo
 */

import SiteLogo from '@package/components/theme/Logo/Logo';

export default SiteLogo;
